export const approvalTableColumns = [
  {
    label: "审批流名称",
    value: "name"
  },
  {
    label: "流程描述",
    value: "desc"
  },
  {
    label: "创建人",
    value: "creator.name"
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]

export const remindTableColumns = [
  {
    label: "提醒规则",
    value: "rule"
  },
  {
    label: "时间节点",
    value: "timeFrame"
  },
  {
    label: "提醒对象",
    value: "userType"
  },
  {
    label: "提醒方式",
    value: "noticeType"
  }
]

export const templateTableColumns = [
  {
    label: "任务类型",
    value: "name",
    minWidth: "160",
    align: "center"
  },
  {
    label: "类型描述",
    value: "description",
    minWidth: "200",
    align: "center"
  },
  {
    label: "关联工作表",
    value: "sheetStr",
    minWidth: "160",
    align: "center"
  },
  {
    label: "填写字段",
    value: "cidStr",
    minWidth: "200",
    align: "center"
  },
  {
    label: "任务审批",
    value: "workflowName",
    minWidth: "160",
    align: "center"
  }
]

export const groupTableColumns = [
  {
    label: "分组名称",
    value: "name"
  }
]
